import React, { useEffect, useState } from "react";
import { DateTime } from "luxon";
import { Cell, Row } from "./StyledTableComponents";

import { useDate } from "../../../utility/useDate";
import { IKmosV2AllocationView } from "../../../logic/api";
import KmosTimeSlotCell from "./KmosTimeSlotCell";

import styles from "./KmosView.module.css";

const KmosTimeSlotRow: React.FunctionComponent<{
  openDialog: () => void;
  setSelectedTsv: (tsv: IKmosV2AllocationView) => void;
  title: string;
  timeSlot: string;
  timeRange: string;
  dates: Date[];
  tsViews: IKmosV2AllocationView[];
}> = (props) => {
  const { localizeDate } = useDate();

  const {
    tsViews,
    dates,
    title: name,
    timeRange,
    openDialog,
    setSelectedTsv,
  } = props;
  const [localizedDateRange, setLocalizedDateRange] = useState<DateTime[]>([]);

  useEffect(() => {
    setLocalizedDateRange(dates.map((date) => localizeDate(date)));
  }, [dates]);

  const areTwoDatesEqual = (
    allocationReturnDate: DateTime,
    listDate: DateTime
  ) => {
    return (
      allocationReturnDate.year === listDate.year &&
      allocationReturnDate.month === listDate.month &&
      allocationReturnDate.day === listDate.day
    );
  };

  const findAllocationViewForDateAndTimeSlot = (
    tsViews: IKmosV2AllocationView[],
    date: DateTime
  ) => {
    return tsViews.find((tsView: IKmosV2AllocationView) =>
      areTwoDatesEqual(localizeDate(tsView.timeSlotDate.date), date)
    );
  };

  return (
    <Row>
      <Cell>
        <div className={styles.slotRow}>
          <div className={styles.slotRowHeader}>
            <span className={styles.slotName}>{name}</span>
            <br />
            <span>{timeRange}</span>
          </div>
        </div>
      </Cell>
      {localizedDateRange.map((date: DateTime, index: number) => {
        const tsView = findAllocationViewForDateAndTimeSlot(
          tsViews,
          localizedDateRange[index]
        );

        return tsView ? (
          <KmosTimeSlotCell
            openDialog={openDialog}
            setSelectedTsv={setSelectedTsv}
            tsView={tsView}
            key={`timeSlot-${index}`}
          />
        ) : (
          <Cell></Cell>
        );
      })}
    </Row>
  );
};

export default KmosTimeSlotRow;
